export class Author {
  objectID: number;
  uuid: string;
  name: string;
  tags: string[];
  image: any;
  role: string;
  createdAt: string;
  createdAtTimestamp: number;
  publishedAt: string;
  publishedAtTimestamp: number;
  slug: string;
  fullSlug: string;

  constructor(raw: any) {
    this.objectID = raw.id;
    this.uuid = raw.uuid;
    this.name = raw.name;
    this.tags = raw.tag_list;
    this.image = raw.content.image;
    this.role = raw.content.role;
    this.createdAt = raw.created_at;
    this.createdAtTimestamp = new Date(raw.created_at).getTime();
    this.publishedAt = raw.published_at;
    this.publishedAtTimestamp = new Date(raw.published_at).getTime();
    this.slug = raw.slug;
    this.fullSlug = raw.full_slug;
  }
}
